import clsx from "clsx";
import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import { getRaceWeekFlagPath } from "../../../Common/utils/cloudinary";
import { cva } from "class-variance-authority";
import {
  CLOUDINARY_IMAGE_BASE_URL,
  IMAGE_VERSION,
} from "../../../Common/constants";
import Media from "../../media";
import { useEffect } from "react";

const RaceweekFlag = ({
  size,
  classes,
  countryName,
  updateFlagSquareImg = () => {},
}) => {
  const { configData, cloudinaryBase, envVersion } = useCloudinaryData();
  const countryShortNames = configData?.countryShortNames;

  const squareRaceWeekFlagArr =
    configData?.squareFlagImg?.raceweekFlags?.countryKey || [];

  const countryFlag = cva("si-countryFlag", {
    variants: {
      size: {
        sm: "si-img--sm",
        md: "si-img--md",
        lg: "si-img--lg",
        xlg: "si-img--xlg",
      },
    },
  });
  const flagImagePath = getRaceWeekFlagPath(
    configData,
    cloudinaryBase,
    envVersion,
    countryName
  );

  const countryShortName = countryShortNames?.[countryName];

  const isSquareFlag = squareRaceWeekFlagArr?.includes(countryShortName);

  useEffect(() => {
    if (isSquareFlag) {
      updateFlagSquareImg(true);
    } else {
      updateFlagSquareImg(false);
    }
  }, [isSquareFlag, updateFlagSquareImg]);

  const divStyle = isSquareFlag
    ? { aspectRatio: "3/2", height: "auto", borderRadius: "0px" }
    : {};
  const imgStyle = isSquareFlag ? { aspectRatio: "3/2", display: "block" } : {};

  return (
    <>
      <div className={clsx(countryFlag({ size }), classes)} style={divStyle}>
        <Media
          imgSrc={flagImagePath}
          imgAlt={countryName}
          restProp={{ style: imgStyle }}
        />
        {/* <img
          src={flagImagePath}
          alt={countryName}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = `${CLOUDINARY_IMAGE_BASE_URL}common/fallback.svg?v=${IMAGE_VERSION}`;
          }}
          loading="lazy"
        /> */}
      </div>
    </>
  );
};

export default RaceweekFlag;
